import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { UrlSerializer } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components/about/about.component';
import { SoporteComponent } from './components/soporte/soporte.component';
import { InstruccionesComponent } from './components/instrucciones/instrucciones.component';
import { PageNotFoundComponent } from './components/pagenotfound/pagenotfound.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { CoreModule } from './components/core/core.module';
import { MantenimientoModule } from './components/_mantenimiento/mantenimiento.module';
import { ImportacionModule } from './components/_importacion/importacion.module';
import { ComunesModule } from './components/_comunes/comunes.module';
import { UrlSerializerHandler } from './components/core/_infrastructure/classes/handlers/urlSerializerHandler';
import { ExceptionHandler } from './components/core/_infrastructure/classes/handlers/exceptionHandler';
import { ProteccionDatosComponent } from './components/protecciondatos/protecciondatos.component';
import { ExportacionModule } from './components/_exportacion/exportacion.module';
import { CampaniasModule } from './components/_campanias/campanias.module';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AppSharedRoutingModule } from './app-shared-routing.module';
import { ErrorComponent } from './components/error/error.component';
import { UsuariosExModule } from './components/_sede/asistentes/altausuariosexternos/altausuariosexternos.module';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { LogoutComponent } from './components/core/components/logout/logout.component';
@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        SoporteComponent,
        AboutComponent,
        InstruccionesComponent,
        ProteccionDatosComponent,
        PageNotFoundComponent,
        NotAuthorizedComponent,
        ErrorComponent,
        LogoutComponent,
    ],
    imports: [
        ConfirmDialogModule,
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        CoreModule,
        ImportacionModule,
        UsuariosExModule,
        ExportacionModule,
        CampaniasModule,
        ComunesModule,
        MantenimientoModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 7000, // 7 sg.
            extendedTimeOut: 1000, // 1 sg.
            positionClass: 'toast-top-right',
            preventDuplicates: true,
        }),
        AppSharedRoutingModule,
    ],
    providers: [
        ConfirmationService,
        {
            provide: ErrorHandler,
            useClass: ExceptionHandler,
        },
        {
            provide: UrlSerializer,
            useClass: UrlSerializerHandler,
        },
    ],
})
export class AppModuleShared {}
